// extracted by mini-css-extract-plugin
export default {"overlay":"dy-z","bodyOpen":"ey-z","content":"fy-z","header":"gy-z","close":"hy-z","closeNoHeading":"iy-z"};